export default "__VITE_ASSET__0a5fcb9c__"